﻿export function getNameLabel(nameAlias: string | null): string {
    return nameAlias ? `Name (${nameAlias})` : 'Name';
}
